// ═══════════════════════════════════════════════════════════════
// PA Grants — Applicant Portal Onboarding
// Shown when user email doesn't match any PA organization
// ═══════════════════════════════════════════════════════════════

import { Title, Text, Paper, ThemeIcon, Stack } from '@mantine/core';
import { IconBuildingCommunity } from '@tabler/icons-react';
import { useAuthStore } from '../../../store/authStore';

export default function PortalOnboarding() {
  const user = useAuthStore(s => s.user);

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ maxWidth: 600, margin: '0 auto', textAlign: 'center' }}>
        <ThemeIcon size={64} radius="xl" variant="light" color="blue" mb="md" style={{ margin: '0 auto' }}>
          <IconBuildingCommunity size={32} />
        </ThemeIcon>
        <Title order={2} mb="xs">Welcome to PA Grants</Title>
        <Text c="dimmed" size="sm" mb="xl">
          Your account is not currently linked to any PA organization.
        </Text>

        <Paper withBorder p="xl">
          <Stack gap="sm">
            <Text size="sm">
              To access your organization's PA projects and documents, an administrator
              needs to add your email address to your organization's authorized contacts.
            </Text>
            <Text size="xs" c="dimmed">
              Signed in as <strong>{user?.email}</strong>
            </Text>
            <Text size="xs" c="dimmed">
              Please contact your PA Administrator or EOC Director to be granted access.
            </Text>
          </Stack>
        </Paper>
      </div>
    </div>
  );
}
